var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vehicle from './Model';
import { api } from '../../helpers/Api';
import { action, observable } from 'mobx';
var VehiclesStore = /** @class */ (function () {
    function VehiclesStore() {
        var _this = this;
        this.loading = true;
        this.vehicles = [];
        this.read = function (id) {
            _this.loading = true;
            if (id) {
                return api.get("vehicles/".concat(id)).then(function (value) {
                    _this.loading = false;
                    return value;
                });
            }
            return api.get('vehicles').then(_this.set);
        };
        this.create = function (data) {
            _this.loading = true;
            return api.post('vehicles', data).then(function (result) { return result; });
        };
        this.update = function (id, data) {
            _this.loading = true;
            return api.put("vehicles/".concat(id), data).then(_this.replace);
        };
        this.disable = function (id, disabled) {
            _this.loading = true;
            return api.patch("vehicules/".concat(id), { disabled: disabled }).then(_this.pull);
        };
        this.set = function (values) {
            // console.log('set - vehicles: ', values)
            _this.loading = true;
            _this.vehicles = values.filter(function (value) { return !value.disabled_at; });
            return _this.vehicles;
        };
        this.push = function (value) {
            _this.loading = false;
            _this.vehicles.push(new Vehicle(value));
        };
        this.replace = function (value) {
            _this.loading = false;
            _this.vehicles.splice(_this.vehicles.findIndex(function (f) { return f.id === value.id; }), 1, value);
        };
        this.pull = function (value) {
            _this.loading = false;
            _this.vehicles.splice(_this.vehicles.findIndex(function (a) { return a.id === value.id; }), 1);
        };
    }
    __decorate([
        observable
    ], VehiclesStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], VehiclesStore.prototype, "vehicles", void 0);
    __decorate([
        action
    ], VehiclesStore.prototype, "read", void 0);
    __decorate([
        action
    ], VehiclesStore.prototype, "update", void 0);
    __decorate([
        action
    ], VehiclesStore.prototype, "disable", void 0);
    __decorate([
        action
    ], VehiclesStore.prototype, "set", void 0);
    __decorate([
        action
    ], VehiclesStore.prototype, "push", void 0);
    __decorate([
        action
    ], VehiclesStore.prototype, "replace", void 0);
    __decorate([
        action
    ], VehiclesStore.prototype, "pull", void 0);
    return VehiclesStore;
}());
export default VehiclesStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Vehicles/Store.ts
// module id = 737
// module chunks = 0